import React, {useState, useEffect} from "react";
import styles from "./styles.module.scss";
import {BsArrowDown, BsArrowUp} from "react-icons/bs";
import {NoData, PageNavigator, Loader} from "../index";
import {useSelector} from "react-redux";
import * as XLSX from 'xlsx';

export default function Table({
                                  headers,
                                  data,
                                  onPageChange,
                                  current,
                                  totalPage,
                                  state,
                                  length,
                                  r_length,
                                  t_length,
                                  exportData,
                                  exportDataFunc,
                                  spLoader,
                                  spPayments
                              }) {
    const [iconAt, setIconAt] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [tableRows, setTableRows] = useState();
    const [sorting, setSorting] = useState({
        sortBy: "",
        sortIn: ""
    });

    const loading = useSelector(state => state.loading);
    

    useEffect(() => {
        setTableRows(data);
        setVisibleRows({});
    }, [data]);

    // Sort rows by given column's heading
    const sortRows = sortBy => {
        if (!tableRows?.length) return;

        const rows = [...tableRows];

        // Sort in descending order
        if (sorting.sortBy !== sortBy || sorting.sortIn !== "ASC") {
            rows?.sort((a, b) => {
                if (!isNaN(a[sortBy]) && !isNaN(b[sortBy]))
                    return a[sortBy] - b[sortBy];

                if (a[sortBy]?.props?.text < b[sortBy]?.props?.text) return -1;
                if (a[sortBy]?.props?.text > b[sortBy]?.props?.text) return 1;
                if (a[sortBy] < b[sortBy]) return -1;
                if (a[sortBy] > b[sortBy]) return 1;
                return 0;
            });
            setSorting({sortIn: "ASC", sortBy});
        } else {
            // Sort in ascending order
            rows?.sort((a, b) => {
                if (!isNaN(a[sortBy]) && !isNaN(b[sortBy]))
                    return b[sortBy] - a[sortBy];

                if (a[sortBy]?.props?.text < b[sortBy]?.props?.text) return 1;
                if (a[sortBy]?.props?.text > b[sortBy]?.props?.text) return -1;
                if (a[sortBy] < b[sortBy]) return 1;
                if (a[sortBy] > b[sortBy]) return -1;
                return 0;
            });
            setSorting({sortIn: "DSC", sortBy});
        }
        setTableRows(rows);
    };

    const setCur = (cpage) =>{
        setCurrentPage(cpage);
    } 
    const get_rows = (tableRows) => {
        if (tableRows) {
            let users = 0
            tableRows.map((user, i) => {
                if (i >= (currentPage - 1) * 10 && i < currentPage * 10) {
                    users += 1
                }
            })
            if (t_length) {
                if (currentPage === 1) {
                    return (
                        <p>Showing data {currentPage} to {users} of
                            entries {state ? length : t_length}
                            {state && ` (filtered from ${t_length} total entries)`}
                        </p>
                    )
                } else {
                    return (
                        <p>Showing
                            data {currentPage - (currentPage - 1) + ((currentPage - 1) * 10)} to {users + ((currentPage - 1) * 10)} of
                            entries {t_length}</p>
                    )
                }
            } else {
                if (currentPage === 1) {
                    return (
                        <p>Showing data {currentPage} to {users} of
                            entries {tableRows.length} {(length && length !== tableRows.length) && `(filtered from ${length} total entries)`}</p>
                    )
                } else {
                    return (
                        <p>Showing
                            data {currentPage - (currentPage - 1) + ((currentPage - 1) * 10)} to {users + ((currentPage - 1) * 10)} of
                            entries {tableRows.length}</p>
                    )
                }
            }
        }
    }

    const [visibleRows, setVisibleRows] = useState({});

    const toggleRow = (index) => {
        setVisibleRows((prev) => ({
            ...prev,
            [index]: !prev[index] // Toggle visibility for the row index
        }));
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
    
        // Extract day and year
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
    
        // Extract month name
        const monthNames = [
            "January", "February", "March", "April", "May", "June", 
            "July", "August", "September", "October", "November", "December"
        ];
        const month = monthNames[date.getMonth()];
    
        // Extract hours and minutes
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
    
        // Determine AM or PM
        const ampm = hours >= 12 ? 'PM' : 'AM';
    
        // Convert hours to 12-hour format
        hours = hours % 12 || 12; // Convert 0 to 12 for AM times
    
        return `${day} ${month}, ${year} ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    }
    


    return (
        <>
            {exportData &&
                <div style={{marginTop: 20}}>
                    <button
                        onClick={exportDataFunc}
                    >Export Data
                    </button>
                </div>
            }
            <div className={styles.table__container}>
                <table>
                    <thead>
                    <tr>
                        {headers?.length &&
                            headers.map((header, index) => (
                                <th
                                    key={index}
                                    onClick={() => {
                                        if (!header?.sortBy || !tableRows?.length) return;
                                        setIconAt(header?.title);
                                        sortRows(header?.sortBy);
                                    }}
                                    className={header?.sortBy && styles.sortable}>
                                    {header?.title || header}
                                    {header?.title && header?.title === iconAt ? (
                                        sorting?.sortIn === "ASC" ? (
                                            <BsArrowDown size="12"/>
                                        ) : (
                                            <BsArrowUp size="12"/>
                                        )
                                    ) : null}
                                </th>
                            ))}

                        {typeof headers === "string" && <th>{headers}</th>}
                    </tr>
                    </thead>

                    <tbody>
                    {tableRows?.length
                        ? tableRows.map((user, i) => {
                            const spPayment = spPayments.filter((item)=>{
                                return item.id == user['id'];
                            })
                            console.log('spPaymentspPaymentspPaymentspPayment ====> '+JSON.stringify(spPayment));
                            const calculate_clykk_fee = (item) => {
                                let sum = 0;
                                item.get_payment_transaction.map((_item) => {
                                    if (_item.amount_before_tax && _item.commission_mount) {
                                        sum += _item.amount_before_tax - _item.commission_mount
                                    }
                                })
                                return sum.toFixed(2);
                            }
                            var totalcomm = 0;
                            
                            if (i >= (currentPage - 1) * 10 && i < currentPage * 10) {
                                
                                return (
                                    <>
                                        <tr key={i} onClick={() => toggleRow(i)}>
                                            {Object.keys(user).map((keyName, j) => {
                                                if(typeof(user[keyName]) == 'string'){
                                                    return <td key={j} dangerouslySetInnerHTML={{ __html: user[keyName] }}></td>;
                                                }else{
                                                    return <td key={j}>{user[keyName]}</td>;
                                                }
                                            })}
                                        </tr>
                                        <tr key={i+'child'} style={{ display: visibleRows[i] ? "table-row" : "none" }}>
                                            <td key={i+'childdata'} colspan="11" dangerouslySetInnerHTML={{__html: `<div class="accordion my-3" id="accordionExample${i}">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0"> <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse${i}" aria-expanded="false" aria-controls="collapse0" style="padding: 1rem 5px;"> <div>    
            <div style="display: flex;"> 
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Cart <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].cart_id}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Order No <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].get_transaction_details.order_id}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Sub Category <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].get_cart_package_details[0].get_sub_category_details?.name}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Package Name <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].get_cart_package_details[0].package_name}
                    </span>
                </p> &nbsp;&nbsp;
                
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Service Time <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].service_time}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Service Date <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].service_date}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Base Price <br> 
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].get_cart_package_details[0].base_price}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Selling Price <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].get_subscription_details[0].get_cart_package_details[0].selling_price}
                    </span>
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Total Commission<br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${spPayment[0].amount}
                    </span> 
                </p> &nbsp;&nbsp;
                <p style="font-size: 16;margin-left: 10;padding: 0 10px;text-align: center;">Clykk Fee <br>
                    <span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px;">
                        ${calculate_clykk_fee(spPayment[0])}
                    </span> 
                </p> &nbsp;&nbsp;
                
            </div> 
        </div> </button> </h2>
        <div id="collapse${i}" class="accordion-collapse collapse" aria-labelledby="heading0" data-bs-parent="#accordionExample${i}">
            <div class="accordion-body" style="color:#fff;"><table style="color:var(--bs-body-color);margin-top: -15px;position: relative;">
                ${spPayment[0].get_payment_transaction.map((item) => {
                    totalcomm = totalcomm+item.commission_mount;
                    return `<tr style="background-color: #ffc19a91;">
                                <td colspan="3">Description: 
                                    <b>Subscription</b>
                                    <b style="display:none;">${item.description.replace('-',' ').toUpperCase()}</b>
                                </td>
                                <td colspan="3">Payment Date: <b>${formatDate(item.created_at)}</b></td>
                            </tr>
                            <tr>
                                <td>Total Amount: <span style="font-weight: 600; "> ${item.amount} </span></td>
                                <td>Amount Paid: <span style="font-weight: 600;"> ${item.amount} </span></td>
                                <td>Amount Before Tax: <span style="font-weight: 600; "> ${item.amount_before_tax} </span></td>
                                <td>Tax Amount: <span style="font-weight: 600; "> ${item.amount-item.amount_before_tax} </span></td>
                                <td>Commission Percentage: <span style="font-weight: 600; color: green;"> ${item.commission} </span></td>
                                <td>Commission to be paid: <span style="font-weight: 600; color: green;"> ${item.commission_mount} </span></td>
                            </tr>`})}
                <tr>
                    <td style="background-color: #d86a9d52;"><b>SP Payment Details :</b> <br><span style="font-size: 12px;color: #000a7e;">${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.created_at)?formatDate(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.created_at):''}</span></td>
                    <td colspan="3"></td>
                    <td><b>Total Payable Commission</b></td>
                    <td><span style="padding: 2px 5px;background-color: #41c4d65c;color: #000;border-radius: 5px;!im;!imm;!i;!;display: block;margin-top: 3px; text-align: center;">${totalcomm}</span></td>
                </tr>
                <tr style="background-color: #d86a9d52;">
                    <td>Payment By: <span style="font-weight: bold;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.payment_by)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.payment_by:'--'} </span></td>
                    <td>Comment: <span style="font-weight: bold;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.comment)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.comment:'--'}</span></td>
                    <td>Transaction: <span style="font-weight: bold;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.transaction_id)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.transaction_id:'--'} </span></td>
                    <td>Payment Type: <span style="font-weight: bold;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.payment_type)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.payment_type:'--'} </span></td>
                    <td>Reference No: <span style="font-weight: bold;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.reference_no)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.reference_no:'--'} </span></td>
                    <td>Total Pay To SP: &nbsp;&nbsp;<span style="font-weight: bold;background-color: green;color: #fff;padding: 4px 15px;border-radius: 5px;"> ${(spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.total)?spPayment[0].get_subscription_details[0].get_s_p_transaction_details?.total:'--'} </span></td>
                </tr>
            </table>
            </div>
        </div>
    </div>
</div>`}}></td>
                                        </tr>
                                    </>
                                );
                            } else return null;
                        })
                        : null}
                    </tbody>
                </table>

                {spLoader ? (
        <div className={styles.loading__container}>
          <Loader />
        </div>
      ) : null}

                {get_rows(tableRows)}

                {!tableRows?.length && !spLoader ? <NoData/> : null}

                {(tableRows?.length > 10 || totalPage > 1) && (
                    <PageNavigator
                        pageCount={
                            totalPage
                                ? totalPage
                                : tableRows?.length
                                    ? Math.ceil(tableRows?.length / 10)
                                    : ""
                        }
                        currentPage={currentPage}
                        onClick={e => {
                            onPageChange(e);
                            //setCurrentPage(e);
                            setCur(e);
                        }}
                    />
                )}
            </div>
        </>
    );
}
